export function isValueEqual(a, b) {
  // If both are null or undefined, treat them as equal
  if (a == null && b == null) return true;
  // Loose equality covers most cases, but you can extend further
  return a == b;
}

export function isRowDirty(currentRow, defaultRow, columns) {
  for (let col of columns) {
    if (!isValueEqual(currentRow[col.field], defaultRow[col.field])) {
      return true;
    }
  }
  return false;
}